var map = {
	"./card-back.svg": 37400,
	"./card-front.svg": 57586,
	"./empty.svg": 50789,
	"./female.svg": 47962,
	"./kuang.svg": 43482,
	"./login-bg.svg": 28563,
	"./logo.svg": 67503,
	"./male.svg": 65653,
	"./noAccount.svg": 71136,
	"./riskLevel.svg": 13547,
	"./riskLevel0.svg": 83985,
	"./riskLevel1.svg": 69600,
	"./riskLevel2.svg": 30611,
	"./riskLevel3.svg": 26882,
	"./riskLevel4.svg": 55405,
	"./riskLevel5.svg": 8044,
	"./simple1.svg": 93505,
	"./simple2.svg": 84018,
	"./simple3.svg": 15011,
	"./simple4.svg": 44828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19832;